var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2937 1.45425C10.2937 1.24874 10.2121 1.05164 10.0668 0.906325C9.92148 0.761007 9.72438 0.679369 9.51887 0.679369L3.31985 0.640625C3.11434 0.640625 2.91725 0.722264 2.77193 0.867582C2.62661 1.0129 2.54497 1.20999 2.54497 1.4155C2.54497 1.62101 2.62661 1.81811 2.77193 1.96342C2.91725 2.10874 3.11434 2.19038 3.31985 2.19038H7.62817L1.21993 8.61412C1.1473 8.68615 1.08966 8.77185 1.05032 8.86628C1.01098 8.96071 0.990723 9.06199 0.990723 9.16428C0.990723 9.26657 1.01098 9.36786 1.05032 9.46228C1.08966 9.55671 1.1473 9.64241 1.21993 9.71444C1.29197 9.78707 1.37767 9.84472 1.47209 9.88406C1.56652 9.9234 1.6678 9.94365 1.77009 9.94365C1.87239 9.94365 1.97367 9.9234 2.06809 9.88406C2.16252 9.84472 2.24822 9.78707 2.32026 9.71444L8.74399 3.29071V7.61452C8.74399 7.82004 8.82563 8.01713 8.97095 8.16245C9.11627 8.30776 9.31336 8.3894 9.51887 8.3894C9.72438 8.3894 9.92148 8.30776 10.0668 8.16245C10.2121 8.01713 10.2937 7.82004 10.2937 7.61452V1.45425Z",
    fill: "#36B4E5"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.aa24e415be45f8a48b5a98ff5814066d.svg";
export { ForwardRef as ReactComponent };